import { type ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: boolean;
}

interface CardRowProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

function CardRoot({ children, className = "", padding = true }: CardProps) {
  return (
    <div
      className={`bg-surface border border-hairline rounded-2xl shadow-card ${padding ? "p-5" : ""} ${className}`}
    >
      {children}
    </div>
  );
}

function CardRow({ children, onClick, className = "" }: CardRowProps) {
  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={`w-full flex items-center gap-3 active:opacity-70 transition-opacity ${className}`}
      >
        {children}
      </button>
    );
  }
  return (
    <div className={`flex items-center gap-3 ${className}`}>{children}</div>
  );
}

export const Card = Object.assign(CardRoot, { Row: CardRow });
